export const parseNode = data => {
	const result = data;
	if (data !== null && result.content && typeof result.content === 'string') {
		result.content = JSON.parse(result.content);
	}

	return result;
};

export const unwrapResults = data =>
	Object.keys(data).reduce(
		(currentData, property) => ({
			...currentData,
			// eslint-disable-next-line no-prototype-builtins
			[property]: data[property]?.hasOwnProperty('edges')
				? data[property].edges.map(({ node }) => parseNode(node))
				: parseNode(data[property]),
		}),
		{}
	);
